/**
 * Template - Data mapper for RFI2 - Packaging
 * Section UID (in template) : Section Path in data
 */
export const rfi2PackagingSectionMapper = {
  //Business Capabilities
  primary_packaging_capabilities:
    'dynamic_sections.business_capability.primary_packaging_capabilities',
  primary_materials: 'dynamic_sections.business_capability.primary_materials',
  primary_packaging_format:
    'dynamic_sections.business_capability.primary_packaging_format',
  quality_assurance: 'dynamic_sections.business_capability.quality_assurance',
  packaging_equipment:
    'dynamic_sections.business_capability.packaging_equipment',
  packaging_equipment_rfid:
    'dynamic_sections.business_capability.packaging_equipment_rfid',
  packaging_equipment_capabilities:
    'dynamic_sections.business_capability.packaging_equipment_capabilities',
  packaging_equipment_capabilities_for_plastics:
    'dynamic_sections.business_capability.packaging_equipment_capabilities_for_plastics',
  factory_registration_license:
    'dynamic_sections.business_capability.factory_registration_license',
  certifications: 'dynamic_sections.business_capability.certifications',
  gmi_information: 'dynamic_sections.business_capability.gmi_information',
  color_and_production_management:
    'dynamic_sections.business_capability.color_and_production_management',

  //Supply Chain
  primary_material_suppliers:
    'dynamic_sections.supply_chain.primary_material_suppliers',

  //Responsible Sourcing
  responsible_sourcing_sustainability_for_packaging:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability_for_packaging',

  //Other Information
  key_factory_personnel:
    'dynamic_sections.other_information.key_factory_personnel',
  factory_automation_level:
    'dynamic_sections.other_information.factory_automation_level',
  employee_information:
    'dynamic_sections.other_information.employee_information',
  factory_ownership: 'dynamic_sections.other_information.factory_ownership',
  //for country specific validation
  additional_factory_information:
    'dynamic_sections.other_information.additional_factory_information',
}
